import React, { Component } from 'react';
import { Modal } from 'reactstrap';
import ReactHtmlParser from 'react-html-parser';

class ShowChildren extends Component {

    render() {
        return (
            <Modal
                isOpen={this.props.modal}
                toggle={this.props.toggle}
                className="modal-dialog-centered rk-modal"
                backdrop={this.props.backdrop}
            >
                <div className="rk-modal__header">
                    <span className="rk-modal__header-icon"><i className="fas fa-info-circle"></i></span>
                    <h5>{this.props.title}</h5>
                    <button type="button" className="rk-modal__close" onClick={() => this.props.toggle()}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <div className="rk-modal__body">
                    <div className="rk-field">
                        <label className="rk-label">Estándar de Seguridad del paciente</label>
                        <p>{this.props.numeral_children.patient_safety_standar}</p>
                    </div>

                    <hr className="rk-divider" />

                    <div className="rk-field">
                        <label className="rk-label">Guía de implementación</label>
                        <p>{ReactHtmlParser(this.props.numeral_children.implementation_guide)}</p>
                    </div>

                    <hr className="rk-divider" />

                    <div className="rk-field">
                        <label className="rk-label">Área/servicio</label>
                        <p>{this.props.numeral_children.service_area}</p>
                    </div>

                    <hr className="rk-divider" />

                    <div className="rk-field">
                        <label className="rk-label">Cláusula ISO</label>
                        <p>{this.props.numeral_children.iso_clause}</p>
                    </div>

                    <hr className="rk-divider" />

                    <div className="rk-field">
                        <label className="rk-label">Procesos</label>
                        {this.props.numeral_children.procesos != undefined && (
                            <ul>
                                {this.props.numeral_children.procesos.map(proceso => (
                                    <li>{proceso.name}</li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                <div className="rk-modal__footer">
                    <button type="button" className="rk-btn rk-btn--ghost" onClick={() => this.props.toggle()}>
                        Cerrar
                    </button>
                </div>
            </Modal>
        );
    }
}

export default ShowChildren;
